import {Component} from 'nospa';


export default class Counter extends Component {
    onInit() {
        this.minus = this.minus.bind(this);
        this.plus = this.plus.bind(this);
        this.onInput = this.onInput.bind(this);

        this.minusRef = this.$getRef('minus');
        this.plusRef = this.$getRef('plus');
        this.inputRef = this.$getRef('input');

        this.setEvents();
        this.toggleClasses();
    }

    setEvents(add = true) {
        const action = add ? 'addEventListener' : 'removeEventListener';

        if (this.minusRef) {
            this.minusRef.el[action]('click', this.minus);
        }

        if (this.plusRef) {
            this.plusRef.el[action]('click', this.plus);
        }

        if (this.inputRef) {
            this.inputRef.el[action]('input', this.onInput);
        }
    }

    minus() {
        if (!this.inputRef) return;

        const value = Number(this.inputRef.el.value) - 1;
        if (!(this.inputRef.el.min > value)) {
            this.inputRef.el.value = value;
        }

        this.toggleClasses();
        jQuery(this.inputRef.el).trigger('change');
    }

    plus() {
        if (!this.inputRef) return;

        const value = Number(this.inputRef.el.value) + 1;
        if (!(this.inputRef.el.max < value)) {
            this.inputRef.el.value = value;
        }

        this.toggleClasses();
        jQuery(this.inputRef.el).trigger('change');
    }

    onInput(e) {
        this.inputRef.el.value = Math.min(
            Math.max(e.target.value, this.inputRef.el.min), this.inputRef.el.max,
        );
        this.toggleClasses();

        jQuery(this.inputRef.el).trigger('change');
    }

    toggleClasses() {
        const val = Number(this.inputRef.el.value);
        const min = this.inputRef.el.min;
        const max = this.inputRef.el.max;

        if (val > min) {
            this.minusRef.el.classList.remove('_disabled');
        }

        if (val < max) {
            this.plusRef.el.classList.remove('_disabled');
        }

        if (val - 1 < min) {
            this.minusRef.el.classList.add('_disabled');
        } else if (val + 1 > max) {
            this.plusRef.el.classList.add('_disabled');
        }
    }

    onDestroy() {
        this.setEvents(false);
    }
}
